import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import * as moment from 'moment'

Vue.use(Router)

const routerOptions = [
  {
    path: '/',
    name: 'home',
    component: 'Home'
  },
  {
    path: '/authen',
    name: 'authen',
    component: 'Authen'
  },
  {
    path: '/paymentMethods',
    name: 'paymentMethods',
    component: 'PaymentMethods'
  },
  {
    path: '/paymentInput/:method',
    name: 'paymentInput',
    component: 'PaymentInput'
  },
  {
    path: '/credit/:method',
    name: 'credit',
    component: 'Credit'
  },
  {
    path: '/qr/:method',
    name: 'qr',
    component: 'QR'
  },
  {
    path: '/scbeasy/:method',
    name: 'scbeasy',
    component: 'ScbEasy'
  },
  //Add PayPlus Method 04/02/26
  {
    path: '/payplus/:method',
    name: 'payplus',
    component: 'PayPlus'
  },
  {
    path: '/paymentProcessing',
    name: 'paymentProcessing',
    component: 'PaymentProcessing'
  },
  {
    path: '/paymentSuccess',
    name: 'paymentSuccess',
    component: 'PaymentSuccess'
  },
  {
    path: '/paymentFail',
    name: 'paymentFail',
    component: 'PaymentFail'
  },
  {
    path: '/billRecieve',
    name: 'billRecieve',
    component: 'BillRecieve'
  },
  {
    path: '/kioskqr',
    name: 'kioskqr',
    component: 'KioskQR'
  },
  {
    path: '/paymentExpired',
    name: 'paymentExpired',
    component: 'PaymentExpired'
  }
]

const routes = routerOptions.map(route => {
  return {
    path: route.path,
    name: route.name,
    component: () => import(`./views/${route.component}.vue`),
    meta: route.meta
  }
})

const router = new Router({
  mode: 'history',
  routes: [
    ...routes,
    {
      path: '*',
      redirect: '/'
    }
  ]
})

const canViewBillReceive = bill => {
  return bill && parseInt(bill.status, 10) >= 4
}

const hasOutstanding = bill => {
  return !bill || parseFloat(bill.outstanding) > 0
}

/* router.beforeEach((to, from, next) => {
  let filter = ['paymentMethods', 'paymentInput', 'credit']
  if (filter.includes(to.name)) {
    store.commit('LOADING')
    store
      .dispatch('getBillDataStatus', to.query.linkcode)
      .then(() => {
        if (
          store.state.billDataStatus > 3 &&
          store.state.billData.total == store.state.billData.paid
        ) {
          next('/billRecieve/?linkcode=' + to.query.linkcode)
        } else {
          next()
        }
      })
      .then(() => {
        store.commit('LOAD_DONE')
      })
  } else {
    next()
  }
}) */

//Fix Expire After Paid
router.beforeEach(async (to, from, next) => {
  let filter = [
    'paymentMethods',
    'paymentInput',
    'credit',
    'qr',
    'scbeasy',
    'payplus',
    'paymentSuccess',
    'authen',
    'billRecieve'
  ]
  const linkcode = to.query.linkcode
  const storedLinkcode = localStorage.getItem('linkcode')

  if (filter.includes(to.name)) {
    //console.log('router start ')

    if (!linkcode) {
      return next('/paymentFail')
    }

    //console.log('linkcode',linkcode)

    // if (
    //   to.name !== 'authen' &&
    //   linkcode != sessionStorage.getItem('linkcode')
    // ) {
    //   return next('/authen/?linkcode=' + linkcode)
    // }

    // ✅ ถ้าเปลี่ยน linkcode → clear token
    if (storedLinkcode && storedLinkcode !== linkcode) {
      //console.log('linkcode changed → clear token')
      localStorage.removeItem('token')
    }

    // update linkcode ล่าสุด
    if (linkcode) {
      localStorage.setItem('linkcode', linkcode)
    }

    const result = await store.dispatch('initPaymentFlow', linkcode)

    if (!result.valid) {
      // ถ้าเป็น 401 → ไป authen
      if (result.unauthorized) {
        return next('/authen/?linkcode=' + linkcode)
      }

      // อื่น ๆ ค่อยไป fail
      return next('/paymentFail/?linkcode=' + linkcode)
    }

    const bill = store.state.billData

    // EXPIRE
    const exp = moment(store.state.expire).toDate()
    if (!exp || exp.getTime() <= new Date().getTime()) {
      //console.log('go expire')
      return next('/paymentExpired/?linkcode=' + linkcode)
    }

    //  ต้อง verify ก่อนเข้า payment
    //console.log('to ' + to.name)
    //console.log('from ' + from.name)

    const needAuth = !!store.state.ref2
    let token = localStorage.getItem('token')

    // ✅ AUTO PASS
    if (!needAuth && !token) {
      //console.log('guest flow → generate token')

      const res = await store.dispatch('authenLink', {
        linkcode,
        password: null
      })

      if (!res.success) {
        return next('/paymentFail/?linkcode=' + linkcode)
      }

      token = localStorage.getItem('token')
    }

    // if (!needAuth && to.name === 'authen') {
    //   return next('/paymentMethods/?linkcode=' + linkcode)
    // }

    if (needAuth && !token && to.name !== 'authen') {
      //console.log('go authen')
      return next('/authen/?linkcode=' + linkcode)
    }

    if (to.name === 'billRecieve' && !canViewBillReceive(bill)) {
      return next(
        `/${
          hasOutstanding(bill) ? 'paymentMethods' : 'paymentSuccess'
        }/?linkcode=${linkcode}`
      )
    }

    if (
      !hasOutstanding(bill) &&
      !canViewBillReceive(bill) &&
      to.name !== 'paymentSuccess'
    ) {
      return next('/paymentSuccess/?linkcode=' + linkcode)
    }

    // PAID
    if (
      canViewBillReceive(bill) &&
      bill.total == bill.paid &&
      to.name !== 'billRecieve' &&
      token
    ) {
      if (store.state.backUrl != null && store.state.backUrl != '') {
        window.location = store.state.backUrl
      } else {
        return next('/billRecieve/?linkcode=' + linkcode)
      }
    }

    return next()
  } else {
    // if (to.name === 'authen') {
    //   const needAuth = !!store.state.ref2
    //   const token = localStorage.getItem('token')

    //   // if (!needAuth) {
    //   //   //Gen token
    //   //   //
    //   //   const res = await store.dispatch('authenLink', {
    //   //     linkcode: linkcode,
    //   //     password: ''
    //   //   })
    //   //   localStorage.setItem('token', res.token)
    //   //   return next('/paymentMethods/?linkcode=' + linkcode)
    //   // }

    //   if (token) {
    //     return next('/paymentMethods/?linkcode=' + linkcode)
    //   }

    //   return next()
    // }
    return next()
  }
})

/* router.beforeEach((to, from, next) => {
  let filter = ['paymentMethods', 'paymentInput', 'credit']
  if (filter.includes(to.name)) {
    store.commit('LOADING')
    store
      .dispatch('initPaymentFlow', to.query.linkcode)
      .then(() => {
        console.log('router expire ' + store.state.expire)
        const exp = moment(store.state.expire).toDate()
        console.log('router ' + exp)
        if(exp.getTime() <= new Date().getTime()){
          console.log('router go Expire')
          next('/paymentExpired/?linkcode=' + to.query.linkcode)
        }
        else if (
          store.state.billDataStatus > 3 &&
          store.state.billData.total == store.state.billData.paid
        ) {
          console.log('router billDataStatus ' + store.state.billDataStatus)
          console.log('router total ' + store.state.billData.total)
          console.log('router paid ' + store.state.billData.paid)
          next('/billRecieve/?linkcode=' + to.query.linkcode)
        } else {
          console.log('router go Next')
          next()
        }
      })
      .then(() => {
        store.commit('LOAD_DONE')
      })
  } else {
    next()
  }
}) */

export default router
